import axios from 'axios';

/**
 * get getTagList
 */
export const getTagList = data => axios.$callAPI(() => axios.get('tags/search', { params: data }));

/**
 * get tagInfo
 */
export const getTagInfo = id => axios.$callAPI(() => axios.get('/tags/' + id));

/**
 * add
 */
export const add = data => axios.$callAPI(() => axios.post('tags/', data));

/**
 * 删除
 */
export const del = id => axios.$callAPI(() => axios.delete('tags/' + id));
/**
 * 批量删除
 */
export const delAll = ids => axios.$callAPI(() => axios.delete('tags/', { data: ids }));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('tags/' + id, data));
